import { FETCH_PROMOTION_VALIDATION } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PROMOTION_VALIDATION:
      return { ...state, [action.payload.id]: action.payload }
    default:
      return state
  }
}
